import 'unfonts.css';
import './styles/globals.css';

import { createRoot } from 'react-dom/client';

import './sentry.js';
import './shims/fetch.js';
import './exodus.js';
import { referrerURL } from '@/utils/referrer';
import Root from './root.js';

if (!referrerURL && !__STANDALONE_MODE__) {
  throw new Error('Unable to get document.referrer from parent window.');
}

const rootElement = document.querySelector('#root');
createRoot(rootElement!).render(<Root />);
